export enum BydOrganisationFonctionsEnum {
  FORMS = 1,
  LIENAR = 2,
}
